import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './app-logo.component.html',
  standalone: false,
  styleUrls: ['./app-logo.component.scss']
})
export class AppLogoComponent {
  @Input() src: string = '../../../assets/icon/logo.png';
  @Input() alt: string = 'App Logo';
  @Input() width: string = 'auto';
  @Input() height: string = 'auto';
  @Input() className: string = '';
  @Input() clickable: boolean = false;
  @Input() showVersion: boolean = false;
  @Input() versionText: string = 'v1.0.0';
  @Input() versionPosition: 'top' | 'bottom' | 'left' | 'right' = 'bottom';
  @Input() enableHover: boolean = false;
  @Input() enablePulse: boolean = false;
  @Input() enableScale: boolean = false;

  get logoClasses(): string {
    const classes = ['app-logo'];

    if (this.className) {
      classes.push(this.className);
    }

    if (this.clickable) {
      classes.push('clickable');
    }

    if (this.enableHover) {
      classes.push('hover-enabled');
    }

    if (this.enablePulse) {
      classes.push('pulse-enabled');
    }

    if (this.enableScale) {
      classes.push('scale-enabled');
    }

    return classes.join(' ');
  }

  get versionClasses(): string {
    const classes = ['app-logo__version'];
    classes.push(`app-logo__version--${this.versionPosition}`);
    return classes.join(' ');
  }

  onLogoClick(): void {
    if (this.clickable) {
      // You can emit an event here if needed
    }
  }
}
